import './ant-collapse.styl';
import Collapse from 'antd/lib/collapse';

export default Collapse;
